import { createIcon } from './icon-utils';

export const StageIcon = createIcon({
  fill: '#D9D9D9',
  path: 'M4.05 15L3 13.95L11.7 5.25H6.75V3.75H14.25V11.25H12.75V6.3L4.05 15Z',
  viewBox: '0 0 18 18',
});
